export function initNavigation() {
	const button = document.querySelector("[data-menu-toggle]");
	const navigation = document.querySelector("[data-navigation]");

	if (!button || !navigation) return;

	const mobile = window.matchMedia("(max-width: 1200px)");

	// Délais d’apparition des éléments du menu.
	navigation.querySelectorAll("li").forEach((item, index) => {
		item.style.setProperty("--menu-index", index);
	});

	const isOpen = () => {
		return button.getAttribute("aria-expanded") === "true";
	};

	const setOpen = (open, restoreFocus = false) => {
		// Le menu desktop reste toujours accessible.
		open = mobile.matches && open;

		navigation.classList.toggle("is-open", open);
		button.setAttribute("aria-expanded", String(open));
		button.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu");

		// Empêche Tab d’atteindre les liens du menu mobile fermé.
		navigation.inert = mobile.matches && !open;

		if (mobile.matches) {
			navigation.setAttribute("aria-hidden", String(!open));
		} else {
			navigation.removeAttribute("aria-hidden");
		}

		if (restoreFocus && mobile.matches) {
			button.focus();
		}
	};

	button.addEventListener("click", () => {
		setOpen(!isOpen());
	});

	// Échap ferme le menu et ramène le focus au bouton.
	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape" && mobile.matches && isOpen()) {
			setOpen(false, true);
		}
	});

	// Fermer après sélection d’un lien.
	navigation.addEventListener("click", (event) => {
		if (mobile.matches && event.target.closest("a")) {
			setOpen(false, true);
		}
	});

	// Fermer lors d’un clic à l’extérieur.
	document.addEventListener("click", (event) => {
		if (mobile.matches && isOpen() && !navigation.contains(event.target) && !button.contains(event.target)) {
			setOpen(false);
		}
	});

	// Fermer si le focus clavier quitte le menu et son bouton.
	document.addEventListener("focusin", (event) => {
		if (mobile.matches && isOpen() && !navigation.contains(event.target) && !button.contains(event.target)) {
			setOpen(false);
		}
	});

	// Réinitialiser lors du passage mobile ↔ desktop.
	mobile.addEventListener("change", () => {
		const focusWasInside = navigation.contains(document.activeElement);

		setOpen(false, mobile.matches && focusWasInside);
	});

	setOpen(false);

	const header = document.querySelector(".c-header");

	if (header) {
		let previousScrollY = Math.max(0, window.scrollY);
		const directionThreshold = 5;

		const updateScrollState = () => {
			const scrollY = Math.max(0, window.scrollY);
			const difference = scrollY - previousScrollY;

			header.classList.toggle("is-scrolled", scrollY > 250);

			if (scrollY <= 250 || isOpen()) {
				header.classList.remove("is-hidden");
				previousScrollY = scrollY;
				return;
			}

			// Ignore les petits mouvements pour éviter le clignotement.
			if (Math.abs(difference) < directionThreshold) return;

			header.classList.toggle("is-hidden", difference > 0);
			previousScrollY = scrollY;
		};

		window.addEventListener("scroll", updateScrollState, { passive: true });

		// Garde le header visible lorsque ses éléments reçoivent le focus.
		header.addEventListener("focusin", () => {
			header.classList.remove("is-hidden");
		});

		updateScrollState();
	}

	setOpen(false);
}
